import { db } from '../services/firebase';

export const settingStore = {

	state: {
		company: {
			name: '',
			address: '',
			owner: '',
			taxNumber: '',
			registrationNumber: '',
			classificationCode: '',
			bankAccount: '',
			responsiblePerson: '',
			phoneNumber: '',
			website: '',
			email: ''
		},
		invoice: {
			defaultIssuePlace: '',
			defaultPaymentDeadline: ''
		}
	},

	init() {
		let companyPromise = new Promise((resolve, reject) => {
			db.collection('settings').doc('company')
				.onSnapshot((doc) => {
					if (doc && doc.exists)
						this.state.company = Object.assign({}, this.company, doc.data());

					resolve();
				}, (error) => {
					reject(error);
				});
		});

		let invoicePromise = new Promise((resolve, reject) => {
			db.collection('settings').doc('invoice')
				.onSnapshot((doc) => {
					if (doc && doc.exists)
						this.state.invoice = Object.assign({}, this.invoice, doc.data());

					resolve();
				}, (error) => {
					reject(error);
				});
		});

		return Promise.all([ companyPromise, invoicePromise ]);
	},

	destroy() {
		db.collection('settings').onSnapshot(() => {})();
	},

	update(data) {
		return Promise.all([
			db.collection('settings').doc('company').set(data.company, { merge: true }),
			db.collection('settings').doc('invoice').set(data.invoice, { merge: true })
		]);
	}

};



// WEBPACK FOOTER //
// ./src/stores/settings.js